import {
  FETCH_EVENTS_REQUEST,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  SET_TIME_FILTER,
} from '../reducers/eventsReducer';
import { eventsApi } from '../../services/api';

// Action creators
export const fetchEventsRequest = () => ({
  type: FETCH_EVENTS_REQUEST,
});

export const fetchEventsSuccess = (events) => ({
  type: FETCH_EVENTS_SUCCESS,
  payload: events,
});

export const fetchEventsFailure = (error) => ({
  type: FETCH_EVENTS_FAILURE,
  payload: error,
});

export const setTimeFilter = (timeFilter) => ({
  type: SET_TIME_FILTER,
  payload: timeFilter,
});

// Thunk action to fetch events
export const fetchEvents = (bbox, from, to) => {
  return async (dispatch) => {
    dispatch(fetchEventsRequest());
    try {
      const response = await eventsApi.getEvents(bbox, from, to, 300);
      dispatch(fetchEventsSuccess(response.data.events));
    } catch (error) {
      dispatch(fetchEventsFailure(error.message));
    }
  };
};

// Thunk action to fetch events by time filter
export const fetchEventsByTimeFilter = (bbox) => {
  return (dispatch, getState) => {
    const { timeFilter } = getState().events;
    const to = new Date();
    const from = new Date(to.getTime() - timeFilter);
    dispatch(fetchEvents(bbox, from, to));
  };
};
